import { Component, Input, OnInit } from 'ng-metadata/core';

import './content-selector-tabs.scss';

/**
 * @ngdoc directive
 * @name mwContentSelectorTabs
 * @module mw.components.contentStream
 *
 * @param {string} [activeTab=''] - Name of the active tab, used for active state management.
 * @description
 * `mw-content-selector-tabs` is a component whose responsibility is manage mw-content-selector-tab active state.
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-selector-tabs active-tab="$ctrl.activeTab"></mw-content-selector-tabs>
 * </hljs>
 */
@Component({
    selector: 'mw-content-selector-tabs',
    template: `
        <div class="mw-content-selector-tabs" ng-transclude></div>
    `,
    legacy: {
        transclude: true
    }
})

export class ContentSelectorTabsComponent implements OnInit {
    @Input('=') activeTab;

    constructor() {
        'ngInject';
    }

    ngOnInit() {}

    isActiveTab(tabName): boolean {
        return this.activeTab === tabName;
    }

    setActiveTab(tabName) {
        this.activeTab = tabName;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/content-selector-tabs/content-selector-tabs.ts